import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { IEmailSettingsData } from "@models/settings/email-settings-data";
import { CommonPageComponent } from "@shared/components/commons/common-page/common-page.component";
import { LoaderComponent } from "@shared/components/commons/loader/loader.component";
import { somethingWentWrong } from "@shared/constants/common-error-messages";
import { IPartialHeaderData } from "@shared/services/header.service";
import { SettingsApiService } from "@shared/services/settings-api.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: 'app-email-settings-page',
  standalone: true,
  templateUrl: 'email-settings-page.component.html',
  styleUrl: '../document-templates-page/document-templates-page.component.scss',
  imports: [
    LoaderComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmailSettingsPageComponent extends CommonPageComponent implements OnInit {
  settingsService = inject(SettingsApiService);
  toastr = inject(ToastrService);

  readonly boltEmailAddress = 'info@pravo.com.au';
  override readonly headerData: IPartialHeaderData = {
    title: 'Email Settings',
    iconClass: 'ic-settings-20',
    backPath: ['/settings']
  };

  emailSettingsData: IEmailSettingsData | null = null;

  override ngOnInit() {
    super.ngOnInit();

    this.isLoading.set(true);

    this.settingsService.loadEmailSettings()
      .subscribe({
        next: (emailSettingsData) => {
          this.emailSettingsData = emailSettingsData ?? null;
          this.isLoading.set(false);
        },
        error: (error) => {
          console.warn('[EmailSettingsPageComponent.loadEmailSettings] error: ', error);
          this.toastr.error(somethingWentWrong, 'Error');
        }
      });
  }
}
